import { environment } from 'src/environments/environment';

export function isUsaPmsEnvironment(): boolean {
  return environment.environment.includes('us') || environment.environment === 'localhost';
}

export function getPmsDashboardPath(): string {
  return isUsaPmsEnvironment() ? '/us/dashboard' : '/dashboard';
}
